import type { GamePlayer } from '../../base/GamePlayer.js'
import { DeckCode } from '../../shared/index.js'
import { initRound } from '../state/round.js'
import { OhHellInProgress } from '../state/state.js'

export type OhHellOptions = {
  rounds: number
  deckCode: DeckCode
}

export const defaultOptions: OhHellOptions = {
  rounds: 12,
  deckCode: DeckCode.TarotSW,
}

export function init(
  players: GamePlayer[],
  hostId: string,
  options: OhHellOptions = defaultOptions,
): OhHellInProgress {
  const deckCode = options.deckCode
  return {
    deckCode: deckCode,
    players,
    roundsToPlay: options.rounds,
    completedRounds: [],
    currentRound: initRound(deckCode, players, 1, hostId),
  }
}
